const list = {
    stockLnventoryReject:[
        {
            label:"",
            prop:"",
            with:"",
            
        },
    ],
}
export default list
